import * as React from "react";

import type { Theme } from "@costar/theme-ui";
import { Anchor, Flex, useThemeUI } from "@costar/theme-ui";

import { HOME_URL } from "../../../common";

import AddListingDropdown from "./add-listing-dropdown";
import { loginHelper } from "./login-helper";
import { RightNavContentProps } from "./types";

function hideAtMobileBreakpoint(theme: Theme) {
    const { breakpoints } = theme;
    return breakpoints
        ? {
              [`${breakpoints.down(0)}`]: {
                  display: "none",
              },
          }
        : {};
}

const RightContent: React.FC<RightNavContentProps> = props => {
    const { loginUrl = HOME_URL, loginLabel = "Login" } = props ?? {};
    const { theme } = useThemeUI() as { theme: Theme };

    return (
        <Flex gap="lg" alignItems="center" flexWrap="nowrap" paddingRight="xxl">
            <Anchor
                variant="text-button"
                fontSize="xs"
                px="xs"
                textProps={{ display: "flex", justifyContent: "center", minWidth: "55px" }}
                height="2em"
                href={loginUrl}
                sx={hideAtMobileBreakpoint(theme)}
                onClick={loginHelper(loginUrl)}
            >
                {loginLabel}
            </Anchor>
            <AddListingDropdown sx={hideAtMobileBreakpoint(theme)} />
        </Flex>
    );
};

export default React.memo(RightContent);
